import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { UserUrl } from '../../shared/urls/user.url';

@Injectable()
export class DataEntryService {
    constructor(public baseService: BaseService) {

    }

    getImpersonatedUser() {
        const url = UserUrl.USER_DATA_ENTRY;
        return this.baseService.getData(url);
        // return  [
        //     {
        //         userId: '1',
        //         title: 'Dr',
        //         firstName: 'Hung',
        //         sureName: 'Vuong',
        //         registrationNumber: '656456456'
        //     },
        //     {
        //         userId: '2',
        //         title: 'Dr',
        //         firstName: 'Hung',
        //         sureName: 'Vuong',
        //         registrationNumber: 'N/A'
        //     },
        //     {
        //         userId: '3',
        //         title: 'Dr',
        //         firstName: 'Hung',
        //         sureName: 'Vuong',
        //         registrationNumber: '3656456456'
        //     }
        // ];
    }

    toggleImpersonatedUserPermission(param) {
        const url = UserUrl.USER_DATA_ENTRY + `/${param.userId}`;
        return this.baseService.put(url, null);
        // return ["page.managecentreuser", "page.accountpayment", "page.cashsale", "page.changepassword", "page.managebooking", "page.managepatientuser", "page.managevaccinestock", "page.newsmemo", "page.report", "page.searchpatient", "page.waitingroom"];
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/header/data-entry.service.ts